export enum StratalotTypeAggrege {
  lotsPrincipaux = 'Lots principaux',
  lotsAnnexes = 'Lots annexes'
}
